import { t, type TranslationKey } from './i18n/translations';

const newPatientProcedureTitles: Record<string, string> = {
  proc711: 'Routinecheck',
  proc713: 'Kinderuntersuch bis 14 Jahre',
  proc916: 'Besprechung Schiene',
};

const isNewPatientBooking = () => {
  if (localStorage.getItem('selectedAppointmentId')?.trim()) return false;
  try {
    const steps = JSON.parse(localStorage.getItem('headerDefinition') ?? 'null');
    // Registration sets loginPatientId before the summary; the steps retain
    // the new-patient context through confirmation.
    if (Array.isArray(steps)) return steps[3] === 'Persönliche Angaben';
  } catch {
    // Without a valid step definition, use the pre-registration patient state.
  }
  return !localStorage.getItem('loginPatientId')?.trim();
};

export const getNewPatientProcedureTitle = (procedureId: string, newPatient: boolean) =>
  newPatient ? newPatientProcedureTitles[procedureId] : undefined;

export const getBookingProcedureName = (
  procedureName?: string,
  procedureId = '',
  newPatient = isNewPatientBooking(),
) => {
  const title = getNewPatientProcedureTitle(procedureId, newPatient);
  if (title) return title;
  if (!procedureName) return 'Behandlung';
  const translatedName = t(procedureName as TranslationKey) || procedureName;
  return translatedName.charAt(0).toUpperCase() + translatedName.slice(1);
};
